import React, {
  useContext,
} from 'react'
import { PopularProducts as CPPopularProducts, Title } from '@usap/widgets'
import {Box, ResponsiveBox, useResponsiveWrapperContext} from '@usap/uicomponents'
import PopularProductsProvider, { PopularProductsContext } from '../../contexts/popularProducts.context'
import { LocalContext } from '../../helpers/useLocalContext'
import useReviews from '../../../hooks/useReviews'
import SeoCarousel from "@usap/widgets/src/components/common/SeoCarousel";

const fontStyleTitle = { fontSize: '20px' }
const popularProductsMainPad = { horizontal: 'small', vertical: 'medium' }
const popularProductsMainMargin = { horizontal: 'auto', vertical: 'medium' }

const PopularProductsView = ({ Link, data }) => {
  const { reviewCount, avgRating } = useReviews(data.productId)
  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext
  return (
    <CPPopularProducts
      Link={Link}
      data={data}
      reviewCount={reviewCount}
      avgRating={avgRating}
      isBot={isBot}
    />
  )
}

const PopularProductsWidget = ({ Link }) => {
  const contextData = useContext(PopularProductsContext)
  const { isDesktop } = useResponsiveWrapperContext()
  const { popularProducts } = contextData || {}
  const isSelectedVehicleAvailable = typeof window !== 'undefined' ? document.getElementById('vehicle-selector') : true
  if (!popularProducts || popularProducts.length === 0 || !isSelectedVehicleAvailable) {
    return null
  }

  return (
    <ResponsiveBox
      id="PopularProducts"
      width="1248px"
      pad={popularProductsMainPad}
      margin={popularProductsMainMargin}
    >
      <Box id="PopularProductsHeading">
        <Title
          type="h2"
          style={fontStyleTitle}
          size="medium"
          label="Popular Products"
        />
      </Box>
      <ResponsiveBox
        id="PopularProductsSection"
      >
        {
          isDesktop && (
            <Box direction="row">
              {
                popularProducts.map(data => (
                  <PopularProductsView key={`PopularProducts-${data.id}`} data={data} Link={Link} />
                ))
              }
            </Box>
          )
        }
        {
          !isDesktop && (
            <SeoCarousel useCarousel={true} movementPoints={180}>
              {
                popularProducts.map(data => (
                  <PopularProductsView key={`PopularProducts-${data.id}`} data={data} Link={Link} />
                ))
              }
            </SeoCarousel>
          )
        }

      </ResponsiveBox>
    </ResponsiveBox>
  )
}

export default function SeoPopularProducts({ dynamicApiData }) {
  const { localContext } = useContext(LocalContext)
  const { Link } = localContext
  const {
    pageType,
    popularProducts,
    products,
    canonicalUri,
    vehicle,
    attributes,
  } = dynamicApiData || {}

  return (
    <PopularProductsProvider
      pageType={pageType}
      products={products}
      popularProduct={popularProducts}
      canonicalUri={canonicalUri}
      vehicle={vehicle}
      attributes={attributes}
    >
      <PopularProductsWidget Link={Link} />
    </PopularProductsProvider>
  )
}
